import React, { useState } from "react";
import {
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Box,
  Menu,
  MenuItem,
  Checkbox,
  ListItemText,
} from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import FilterListIcon from "@mui/icons-material/FilterList";
import PlayersTableBody from "./PlayersTableBody";

const PlayersTable = ({ players, onMenuOpen, onSortByName, onSortByStatus, onFilterByStatus, selectedStatuses, sortField, sortDirection }) => {
  const [filterMenuAnchor, setFilterMenuAnchor] = useState(null);
  const statusOptions = ['available', 'injured', 'suspended', 'unknown'];

  const handleFilterMenuOpen = (event) => {
    setFilterMenuAnchor(event.currentTarget);
  };

  const handleFilterMenuClose = () => {
    setFilterMenuAnchor(null);
  };

  const handleStatusToggle = (status) => {
    onFilterByStatus(status);
  };
  
  return (
    <TableContainer>
      <Table sx={{ borderCollapse: "separate", borderSpacing: "0 8px" }}>
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                backgroundColor: "transparent",
                borderBottom: "none",
                color: "#464A53",
              }}
            >
              Headshot
            </TableCell>
            <TableCell
              sx={{
                backgroundColor: "transparent",
                borderBottom: "none",
                display: "flex",
                alignItems: "center",
                color: "#464A53",
              }}
            >
              <Box display="flex" alignItems="center">
                Name
                <Box ml={0.5} display="flex" flexDirection="column">
                  <Button 
                    size="small" 
                    sx={{ 
                      minWidth: 0, 
                      padding: 0,
                      color: sortField === 'name' && sortDirection === 'asc' ? '#1976d2' : '#464A53'
                    }} 
                    onClick={() => onSortByName('asc')}
                  >
                    <KeyboardArrowUpIcon fontSize="small" />
                  </Button>
                  <Button 
                    size="small" 
                    sx={{ 
                      minWidth: 0, 
                      padding: 0,
                      color: sortField === 'name' && sortDirection === 'desc' ? '#1976d2' : '#464A53'
                    }} 
                    onClick={() => onSortByName('desc')}
                  >
                    <KeyboardArrowDownIcon fontSize="small" />
                  </Button>
                </Box>
              </Box>
            </TableCell>
            <TableCell
              sx={{
                backgroundColor: "transparent",
                borderBottom: "none",
                color: "#464A53",
              }}
            >
              <Box display="flex" alignItems="center">
                Status
                <Box ml={0.5} display="flex" flexDirection="column">
                  <Button 
                    size="small" 
                    sx={{ 
                      minWidth: 0, 
                      padding: 0,
                      color: sortField === 'status' && sortDirection === 'asc' ? '#1976d2' : '#464A53'
                    }} 
                    onClick={() => onSortByStatus('asc')}
                  >
                    <KeyboardArrowUpIcon fontSize="small" />
                  </Button>
                  <Button 
                    size="small" 
                    sx={{ 
                      minWidth: 0, 
                      padding: 0,
                      color: sortField === 'status' && sortDirection === 'desc' ? '#1976d2' : '#464A53'
                    }} 
                    onClick={() => onSortByStatus('desc')}
                  >
                    <KeyboardArrowDownIcon fontSize="small" />
                  </Button>
                </Box>
                <Button 
                  size="small" 
                  sx={{ 
                    minWidth: 0, 
                    padding: 0,
                    ml: 0.5
                  }} 
                  onClick={handleFilterMenuOpen}
                >
                  <FilterListIcon fontSize="small" />
                </Button>
                <Menu
                  anchorEl={filterMenuAnchor}
                  open={Boolean(filterMenuAnchor)}
                  onClose={handleFilterMenuClose}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                >
                  {statusOptions.map((status) => (
                    <MenuItem key={status} onClick={() => handleStatusToggle(status)}>
                      <Checkbox 
                        checked={selectedStatuses.includes(status)} 
                        size="small"
                      />
                      <ListItemText>{status.charAt(0).toUpperCase() + status.slice(1)}</ListItemText>
                    </MenuItem>
                  ))}
                </Menu>
              </Box>
            </TableCell>
            <TableCell
              sx={{
                backgroundColor: "transparent",
                borderBottom: "none",
                color: "#464A53",
              }}
            >
              Team
            </TableCell>
            <TableCell
              sx={{
                backgroundColor: "transparent",
                borderBottom: "none",
                color: "#464A53",
              }}
            >
              Position
            </TableCell>
            <TableCell
              sx={{
                backgroundColor: "transparent",
                borderBottom: "none",
                color: "#464A53",
              }}
            >
              Price
            </TableCell>
            <TableCell
              sx={{
                backgroundColor: "transparent",
                borderBottom: "none",
                color: "#464A53",
              }}
            >
              Selected By
            </TableCell>
            <TableCell
              sx={{
                backgroundColor: "transparent",
                borderBottom: "none",
                color: "#464A53",
              }}
            >
              Visible
            </TableCell>
            <TableCell
              sx={{
                backgroundColor: "transparent",
                borderBottom: "none",
                color: "#464A53",
              }}
            >
              Left League
            </TableCell>
            <TableCell
              sx={{ backgroundColor: "transparent", borderBottom: "none" }}
            />
          </TableRow>
        </TableHead>
        <PlayersTableBody players={players} onMenuOpen={onMenuOpen} />
      </Table>
    </TableContainer>
  );
};

export default PlayersTable;
